module.exports = __webpack_public_path__ + "static/media/whatsapp.609880d7.svg";